/**
 * Breakpoint values in pixels, matching `@launchpad-ui/tokens/dist/media-queries.css`
 */
export const breakpoints = {
  MOBILE: 739,
  TABLET: 991,
  DESKTOP: 1199,
  WIDE: 1200,
} as const;

/**
 * These (except for "wide") are the inverse of the queries found in `@launchpad-ui/tokens/dist/media-queries.css`
 */
export const mediaQueries = {
  MOBILE: `(max-width: ${breakpoints.MOBILE}px)`,
  TABLET: `(max-width: ${breakpoints.TABLET}px)`,
  DESKTOP: `(max-width: ${breakpoints.DESKTOP}px)`,
  WIDE: `(min-width: ${breakpoints.WIDE}px)`,
} as const;
